export var EventType;
(function (EventType) {
    EventType["PAGE"] = "page";
    EventType["IDENTIFY"] = "identify";
    EventType["DETECT"] = "detect";
    EventType["CONNECT"] = "connect";
    EventType["DISCONNECT"] = "disconnect";
    EventType["CHAIN"] = "chain";
    EventType["SIGNATURE"] = "signature";
    EventType["TRANSACTION"] = "transaction";
    EventType["TRACK"] = "track";
})(EventType || (EventType = {}));
export var EventChannel;
(function (EventChannel) {
    EventChannel["WEB"] = "web";
    EventChannel["MOBILE"] = "mobile";
    EventChannel["SERVER"] = "server";
    EventChannel["SOURCE"] = "source";
})(EventChannel || (EventChannel = {}));
//# sourceMappingURL=events.js.map